import { render, staticRenderFns } from "./ManageResource.modal.vue?vue&type=template&id=5f351890"
import script from "./ManageResource.modal.vue?vue&type=script&lang=ts"
export * from "./ManageResource.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageResource.modal.vue?vue&type=style&index=0&id=5f351890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports